import { IoMdAddCircle, IoMdRemoveCircle } from "react-icons/io";

const AdminUserBusinessListItem = ({
  avatar,
  name,
  action,
  handler,
}: {
  avatar: string;
  name: string;
  action: "add" | "remove";
  handler: Function;
}) => {
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "row",
        justifyContent: "space-between",
        gap: "10px",
        alignItems: "center",
        border: "1px solid #e0e0e0",
        padding: 3,
        cursor: "default",
        width: "100%",
      }}
    >
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          gap: "10px",
        }}
      >
        <img
          src={avatar}
          alt=""
          style={{
            width: "50px",
            height: "50px",
            borderRadius: "50%",
            border: "1px solid #e0e0e0",
          }}
        />
        <p>{name}</p>
      </div>
      {action === "add" ? (
        <IoMdAddCircle
          style={{
            marginRight: "10px",
            fontSize: "20px",
            color: "green",
            cursor: "pointer",
          }}
        />
      ) : (
        <IoMdRemoveCircle
          style={{
            marginRight: "10px",
            fontSize: "20px",
            color: "red",
            cursor: "pointer",
          }}
        />
      )}
    </div>
  );
};

export default AdminUserBusinessListItem;
